export interface SocialLoginState {
  error?: 'deactivated' | 'invalid_email' | 'email_in_use' | 'general';
  isFacebookSDKInitialized?: boolean;
}

// Synced with backend SOCIAL_LOGIN_* constants
export enum SocialLoginProvider {
  Google = 4,
  Apple = 7,
  Facebook = 8,
  Test = 5,
}
